/**
 * The one place the tenant-facing support line is written down.
 *
 * It was previously copied into four screens as a raw `tel:` string, and when the number changed
 * two of them were missed — so a stuck tenant tapping "Call CirclePe Agent" on the Congrats or
 * Rent Summary screen reached a line nobody answers. That is the worst possible moment for a dead
 * number, and it stayed broken because nothing tied the copies together.
 *
 * Import these instead of typing a number. If the line changes again, it changes here.
 */

/** E.164, for `tel:` — the dialler needs the country code to resolve correctly. */
export const SUPPORT_PHONE_E164 = "+919650570479";

/** WhatsApp click-to-chat wants the digits only: no leading "+", no spaces. */
export const SUPPORT_WHATSAPP_NUMBER = "919650570479";

/** Ready-made `tel:` href, so no call site has to remember which format goes where. */
export const SUPPORT_TEL_HREF = `tel:${SUPPORT_PHONE_E164}`;
